import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sa-top-selling-products-card card mb-4 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "basic-table table-responsive" }
const _hoisted_5 = { class: "table mb-0" }
const _hoisted_6 = { class: "employee-info d-flex align-items-center" }
const _hoisted_7 = { class: "img border-radius" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "d-block text-body" }
const _hoisted_10 = { class: "fw-semibold" }
const _hoisted_11 = { class: "ratings lh-1" }
const _hoisted_12 = {
  key: 0,
  class: "ri-star-half-line"
}
const _hoisted_13 = { class: "d-inline-block lh-1 text-xs text-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Top Selling Products")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          src: product.image,
                          class: "border-radius",
                          alt: "stock-image"
                        }, null, 8, _hoisted_8)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_RouterLink, {
                          to: product.link,
                          class: "d-block fw-semibold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(product.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createElementVNode("span", _hoisted_9, [
                          _createElementVNode("strong", _hoisted_10, _toDisplayString(product.sold), 1),
                          _cache[0] || (_cache[0] = _createTextVNode(" sold ", -1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fullStars(product.rating), (star) => {
                        return (_openBlock(), _createElementBlock("i", {
                          key: 'full-' + star,
                          class: "ri-star-fill"
                        }))
                      }), 128)),
                      (_ctx.hasHalfStar(product.rating))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emptyStars(product.rating), (star) => {
                        return (_openBlock(), _createElementBlock("i", {
                          key: 'empty-' + star,
                          class: "ri-star-line"
                        }))
                      }), 128)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(product.rating), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}